export const biuroData = {
    order: 1,
    name: 'biuro',
    title: 'Biuro',
    iconSrc: 'pic_biuro.svg',
    headlineText:
        'Twoje biuro może też być przyjazne dla środowiska. Zobacz, jakie zmiany wprowadzić i od czego zacząć.',
    mainText:
        'Warto zadbać, aby każde miejsce pracy było przyjazne dla środowiska. Wbrew pozorom, praca biurowa także generuje wiele odpadów. Przede wszystkim można ograniczyć ilość wyrzucanej makulatury. Oszczędzanie papieru i przeznaczanie go do recyklingu to ogromna oszczędność – każde 100 kg papieru to wycięcie dwóch średniej wielkości drzew, a powtórne użycie tony papieru to ocalenie aż 17 drzew! Wykorzystując powtórnie tonę papieru, oszczędzamy blisko półtora tysiąca litrów ropy, 26 tysięcy litrów wody, a także miejsce na składowisku papieru. Jak dbać o ekologię w biurze?',
    mainVideoSrc: '',
    odpadySection: [
        {
            text:
                'Nie drukuj każdego dokumentu czy e-maila – dokumenty przechowuj na nośniku elektronicznym, a przeglądaj je na ekranie.',
        },
        {
            text: '',
            picSrc: 'pics/pic-23.png',
            caption:
                'Do produkcji 1 kg papieru potrzeba 2-3 razy tyle materiału pozyskanego z drzew.',
        },
        {
            text: 'Jeśli masz możliwość, korzystaj z e-faktur.',
        },
        {
            text:
                'Jeśli już coś drukujesz, zwróć uwagę na to, jaki papier kupujesz – czy pochodzi z  recyklingu, albo czy posiada certyfikat FSC. Pamiętaj też o drukowaniu dwustronnym.',
        },
        {
            text: '',
            picSrc: 'pics/pic-24.png',
            caption:
                'Gdyby każda osoba na świecie używała w ciągu roku 200 kg papieru, na Ziemi nie byłoby już żadnych drzew.',
        },
        {
            text:
                'Niewykorzystany papier (np. zadrukowany jednostronnie) oddaj dzieciom do zabawy lub przeznacz na notatki.',
        },
        {
            text:
                'Dostosuj wielkość i rodzaj czcionki oraz akapity w drukowanym tekście tak, aby oszczędne korzystać z papieru.',
        },
        {
            text: '',
            picSrc: 'pics/pic-25.png',
            caption: 'Jedna kartka A4 to 10 litrów wody potrzebnych do jej wytworzenia.',
        },
        {
            text:
                'W przypadku gazet, czasopism czy katalogów, korzystaj z ich wersji online – nie zamawiaj papierowych odpowiedników.',
        },
        {
            text:
                'Bilety na przejazd komunikacją miejską, do kina czy na koncert możesz okazać w wersji elektronicznej.',
        },
        {
            text: '',
            picSrc: 'pics/pic-26.png',
            caption:
                'Każda tona papieru przeznaczona do recyklingu to ratunek dla: 17 drzew, 1,440 litrów ropy, 2.3 m3 przestrzeni na wysypiskach, 4,000 kW energii i 26,500 litrów wody.',
        },
        {
            text:
                'Nie inwestuj w ekspres kapsułkowy – generuje on masę niebiodegraowalnych odpadów.',
        },
        {
            text:
                'Jeśli masz taką możliwość, zadbaj o to, aby w twoim miejscu pracy znalazły się dystrybutory wody źródlanej – nie trzeba będzie korzystać z wody butelkowanej, a kubki jednorazowe zamień na własny kubek.',
        },
    ],
    klimatSection: [],
    energiaSection: [
        {
            text: 'Korzystając z ekspresu, wyłączaj go po przygotowaniu kawy.',
        },
        {
            text:
                'Staraj się wpuścić do pomieszczeń biurowych jak najwięcej światła naturalnego – Twoje oczy będą mniej zmęczone.',
        },
        {
            text:
                'Latem na klimatyzatorze ustaw temperaturę o 5-7°C niższą od panującej na zewnątrz – nie będzie pracowała na maksymalnej wydajności, a tym samym będzie pobierać mniej energii.',
        },
        {
            text: 'Większość komputerów ma funkcje zarządzania energią – korzystaj z nich.',
        },
        {
            text:
                'Ustaw tryb automatycznego przełączania monitora w stan uśpienia po kilku minutach bezczynności komputera i wyłączania monitora po 30 minutach bezczynności. Najlepszy „wygaszacz ekranu” to wyłączony monitor.',
        },
    ],
    powietrzeSection: [],
    wodaSection: [],
    czyWieszSection: [
        {
            text: '...przeciętny mieszkaniec Ziemi zużywa rocznie około 50 kg papieru?....',
            more:
                'W krajach Unii Europejskiej odzyskiwane jest średnio 70% makulatury, podczas gdy w Polsce wynik ten jest niestety dużo słabszy – zaledwie 42%.',
        },
        {
            text:
                '...recykling odpadów celulozowych to redukcja zanieczyszczenia wód i powietrza oraz ochrona przed wycięciem miliardów drzew?...',
            more:
                'Recykling pozwala zao­szczędzić energię (65% oszczędności w stosunku do energii zużywanej w procesie produkcji papieru z włókien pierwotnych) oraz zmniejszyć zanieczyszczenie wody (o 35%) i powietrza (o 74%).' +
                '<br /><br /><a target="_blank" rel="noopener noreferrer" href="https://przekroj.pl/kultura/siodme-zycie-papieru-aleksandra-kozlowska">https://przekroj.pl/kultura/siodme-zycie-papieru-aleksandra-kozlowska</a>',
        },
    ],
};
